<form [formGroup]="formAdicionarPerfil" class="page-perfil" (ngSubmit)="habilitarPerfil()">
  <breadcrumb
    [paginas]="[
      { route: '/home', name: 'Home' },
      { route: '/perfil-conviva-manage', name: 'Perfis Habilitados no Conviva' }
    ]"
  />

  <section class="section-saudacao">
    <div class="container">
      <h2 class="titulo-page">Perfis Habilitados no Conviva</h2>
    </div>
  </section>

  <section class="section-filtro">
    <div class="container">
      <div class="container-btns">
        <button type="button" class="btn_primary" (click)="abrirFormularioAdicionar()">
          Adicionar Perfil
        </button>
      </div>
    </div>
  </section>

  <section class="section-filtro" *ngIf="exibirFormularioAdicionar">
    <div class="container">
      <div class="grupo-filter">
        <p><b>Perfil da SED</b></p>
        <ng-select
          [items]="perfisDisponiveis"
          bindLabel="descricaoPerfil"
          placeholder="Selecione um perfil para habilitar no Conviva"
          formControlName="codigoPerfil"
          name="codigoPerfil"
        >
        </ng-select>
      </div>
      <div class="container-btns acoes-formulario">
        <button type="submit" class="btn_primary">Confirmar</button>
        <button type="button" class="btn_secondary" (click)="fecharFormularioAdicionar()">Cancelar</button>
      </div>
    </div>
  </section>

  <section class="section-table" *ngIf="perfisConviva.length > 0">
    <div class="container">
      <table class="row-border hover" aria-describedby="perfis-conviva">
        <caption>Perfis com acesso habilitado no Conviva</caption>
        <thead>
          <tr>
            <th>Código Perfil</th>
            <th>Nome Perfil</th>
            <th>Comportamento</th>
            <th>Funcionalidades Ativas</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let perfil of perfisConviva">
            <td>{{ perfil.codigoPerfil }}</td>
            <td>{{ perfil.nomePerfil }}</td>
            <td>{{ perfil.numeroComportamento }}</td>
            <td>{{ perfil.quantidadeFuncionalidadesAtivas }}</td>
            <td>
              <button
                type="button"
                class="btn_inativar"
                title="Inativar perfil no Conviva"
                aria-label="Inativar perfil no Conviva"
                (click)="abrirModalInativar(perfil)">
                Inativar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <section class="section-filtro" *ngIf="perfisConviva.length === 0">
    <div class="container">
      <p>Nenhum perfil habilitado no Conviva.</p>
    </div>
  </section>
</form>

<app-modal *ngIf="showModalInativarPerfil">
  <div class="container-conviva form-registro modal-envolvidos">
    <div>
      <h1 class="titulo-page blue">Inativar Perfil</h1>
    </div>
    <hr size="20" />
    <div class="descricao-modal-excluir">
      <span>
        Deseja inativar o perfil "{{ perfilParaInativar?.nomePerfil }}" no Conviva?
        O acesso ao sistema será bloqueado para este perfil.
      </span>
    </div>
    <hr size="20" />
    <div class="container-btns">
      <input type="button" (click)="fecharModalInativar()" class="btn_outline" value="Não" />
      <input type="button" (click)="confirmarInativarPerfil()" class="btn_primary" value="Sim" />
    </div>
  </div>
</app-modal>

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Carregando ...</p>
</ngx-spinner>
